/*
 * Copyright (c) 2025-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Input} from '@angular/core';
import {INoRowsOverlayAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'app-custom-no-rows-overlay',
    template: `<div class="custom-no-rows" [class.loading-overlay]="isLoadingMessage">{{ message }}</div>`,
    styles: [`
        .custom-no-rows {
            padding: 1rem;
            font-size: 1.1rem;
            font-style: italic;
            color: #666;
            text-align: center;
        }
        .custom-no-rows.loading-overlay {
            font-size: xx-large;
        }
    `],
    standalone: false
})
export class CustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
    @Input() message = 'No data available.';
    isLoadingMessage = false;

    agInit(params: any): void {
        this.message = typeof params?.messageGetter === 'function'
            ? params.messageGetter()
            : (params?.message ?? this.message);
        this.isLoadingMessage = typeof params?.isLoadingGetter === 'function'
            ? params.isLoadingGetter()
            : !!params?.isLoadingMessage;
    }
}
